import config from '../../config/config';

export const SPENDBACK_FAILURE = 'SPENDBACK/SPENDBACK_FAILURE';
export const SPENDBACK_LOAD = 'SPENDBACK/SPENDBACK_LOAD';
export const SPENDBACK_SUCCESS = 'SPENDBACK/SPENDBACK_SUCCESS';

export function getSpendback(spendbackId) {
    return {
        failureActionTypeOrCreator: getSpendbackFailureActionCreator,
        fetchParams: {
            url: `${config.payoutApiUrl}/spendback/${spendbackId}`
        },
        loadActionTypeOrCreator: SPENDBACK_LOAD,
        successActionTypeOrCreator: getSpendbackSuccessActionCreator
    };
}

export function getSpendbackFailureActionCreator(error) {
    return {
        error,
        type: SPENDBACK_FAILURE
    };
}

export function getSpendbackSuccessActionCreator(spendback) {
    return {
        spendback,
        type: SPENDBACK_SUCCESS
    };
}
